import { AgGridReact } from "ag-grid-react";
import { useRef } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_PRD1020_R01 } from "./Content_PRD1020_R01";
import { PRD1020_R01Dto } from "./Dto_PRD1020_R01";
import { SearchSection_PRD1020_R01 } from "./SearchSection_PRD1020_R01";
import { usePRD1020_R01Store } from "./Store_PRD1020_R01";
import { Table_PRD1020_R01 } from "./Table_PRD1020_R01";

/**
 * PRD1020_R01 화면의 최상위 조합 컴포넌트다.
 * Actionbar 이벤트를 Content의 조회·엑셀 처리와 Store 초기화에 연결하고,
 * 검색조건과 조회 전용 Grid가 같은 화면 Store를 사용하도록 배치한다.
 * 이 컴포넌트에는 최초 진입 자동 조회가 없으므로 목록 조회는 조회 버튼으로만 시작된다.
 */
export const Container_PRD1020_R01 = () => {
	// Grid API 접근용 ref는 Table에 전달되며 공통 Grid 훅의 행 식별·상태 처리에 사용된다.
	const gridRef = useRef<AgGridReact<PRD1020_R01Dto>>(null);
	const { initData } = usePRD1020_R01Store();
	const { setMessage } = useUiuxStore();
	const { fetchData, handleExcelClick } = Content_PRD1020_R01({ setMessage });

	return (
		<div className="content-container">
			{/* 등록·수정·삭제 없이 조회, Excel, 초기화 동작만 화면에 연결한다. */}
			<Actionbar
				onFetchClick={fetchData}
				onInitClick={initData}
				onExcelClick={handleExcelClick}
			/>
			<SearchSection_PRD1020_R01 />
			<div className="flex flex-1 p-[12px] min-h-0">
				<div className="h-full w-full">
					<Table_PRD1020_R01 gridRef={gridRef} />
				</div>
			</div>
			<Message />
		</div>
	);
};
